import { LanguageDetectorAsyncModule } from "i18next";

const SySiteLanguageDetector: LanguageDetectorAsyncModule & { portalId: string, siteApi: HTMLSySiteApiElement } = {
  type: 'languageDetector',
  async: true,
  portalId: "",
  siteApi: null,
  init: function(_services, options: { catalogByLanguagePromise: Promise<any>  }, _i18nextOptions) {
    this.catalogByLanguagePromise = options.catalogByLanguagePromise;
  },
  detect: async function(callback) {
    const catalogByLanguage = await this.catalogByLanguagePromise;
    
    const getLanguage = () => {
      const findLangByPath = (languagePath) => {
        return catalogByLanguage.find(config => config.path === languagePath)?.language;
      };

      const languagePath = window.location.pathname.split("/").find(path => path.match(/^([a-z]{2})$/)) ?? null;
      return findLangByPath(languagePath) ?? "en"
    }
    
    window.addEventListener('popstate', (_e: PopStateEvent) => {
      callback(getLanguage());
    });

    callback(getLanguage());

  },
  cacheUserLanguage: (_lng) => {}
}

export default SySiteLanguageDetector
